const createActiveClass = (selectedOption, name) =>
  selectedOption === name ? "active" : "";

export default createActiveClass;
